<template>
  <form @submit.prevent="onSubmit">
    <b-form-group
      :label="$trans.get('auth.login.email_address') + '*'"
      :label-for="prefix + 'email_field'"
      :state="form.errors.state('email')"
      :invalid-feedback="form.errors.get('email')"
    >
      <b-form-input
        :id="prefix + 'email_field'"
        v-model="form.data.email"
        :state="form.errors.state('email')"
      />
    </b-form-group>

    <b-form-group
      :label="$trans.get('auth.login.password') + '*'"
      :label-for="prefix + 'password_field'"
      :state="form.errors.state('password')"
      :invalid-feedback="form.errors.get('password')"
    >
      <b-form-input
        :id="prefix + 'password_field'"
        v-model="form.data.password"
        type="password"
        :state="form.errors.state('password')"
      />
    </b-form-group>

    <b-btn
      type="submit"
      variant="success"
      block
      class="float-right mt-1 mb-2 my-lg-3"
    >
      {{ $trans.get('auth.login') }}
    </b-btn>
    
    <button
      v-if="register"
      type="button"
      class="btn btn-block btn-secondary btn-sm mt-3"
      @click="onRegisterClicked"
    >
      {{ $trans.get('auth.register') }}
    </button>

    <a
      :href="passwordRequest"
      class="mt-2"
    >
      {{ $trans.get('auth.forgot_your_password') }}
    </a>
  </form>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator'
  import VueForm from '~/form/form';

  @Component
  export default class LoginForm extends Vue {
    @Prop(String) register;
    @Prop(String) passwordRequest;
    @Prop(String) prefix;

    form = new VueForm({
      email: '',
      password: ''
    });

    onSubmit() {
      this.form.post(window.login_url)
        .then((redirect) => {
          window.location.href = redirect;
        });
    }

    onRegisterClicked() {
      document.location.href = this.register;
    }
  }
</script>
